import React from "react";
import classNames from "classnames";
import styled from 'styled-components';
import { getReplacedContent, parseHTML } from "../../utilities/markdown";
import { ICardProps } from ".";

const SolidColorCardContainer = styled.div`
padding: 1.778rem 1.333rem;
border: 0;
border-radius: 4px;
color: #FFFFFF;

&.bg-white {
    color: #000000;
}

.card-body {
    .custom-card-title {
        font-size: 1.333rem;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
    }
    
    .custom-card-text {
        font-size: 1.111rem;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        margin-bottom: 2.667rem;
    }
}

.card-footer {
    font-size: 0.778rem;
    font-weight: 400;
    line-heihgt: 0.889rem;
}

@media(max-width:768px) {
    .card-body {
        .custom-card-title {
            font-size: 1.111rem;
        }
        
        .custom-card-text {
            font-size: 0.889;
        }
    }
}
`;

const SolidColorCard = (props: ICardProps) => {
    const { className, editorClassObj, cmsId, cardTitle, cardBody, cardFooter, backgroundColor } = props;
    return (
        <SolidColorCardContainer data-id={cmsId} className={classNames(className, editorClassObj, backgroundColor, 'card')}>
            <div className="card-body p-0">
                <h3 className="custom-card-title m-0 mb-3">
                    {typeof cardTitle === 'string' ? parseHTML(cardTitle, 'SolidColor') : getReplacedContent(cardTitle)}
                </h3>
                <div className="custom-card-text mb-4">
                    {typeof cardBody === 'string' ? parseHTML(cardBody, 'SolidColor') : getReplacedContent(cardBody)}
                </div>
            </div>
            <div className="card-footer border-0 p-0">
                {typeof cardFooter === 'string' ? parseHTML(cardFooter, 'SolidColor') : getReplacedContent(cardFooter)}
            </div>
            
        </SolidColorCardContainer>
    );
};

export default SolidColorCard;